export const SET_USER = 'SET_USER';
export const SET_SEARCH_POSITION = 'SET_SEARCH_POSITION';
export const SET_SEARCH_ITEM = 'SET_SEARCH_ITEM';
export const SET_SEARCH_HEADER = 'SET_SEARCH_HEADER';

export function setUser(user) {
    return{
        type: SET_USER,
        payload: user
    }
}

export function setSearchPosition(position) {
    return{
        type: SET_SEARCH_POSITION,
        payload: position
    }
}

export function setSearchItem(item) {
    return{
        type: SET_SEARCH_POSITION,
        payload: item
    }
}

export function searchHeader(flag) {
    return{
        type: SET_SEARCH_HEADER,
        payload: flag
    }
}
